import React from 'react';

interface NumberedSectionProps {
  id: string;
  /** Roman numeral as content ("III"), never a CSS counter — toggling a section off must not renumber the rest. */
  numeral: string;
  title: string;
  children: React.ReactNode;
  tight?: boolean;
}

/**
 * "III.        WHY MELIO?" over a hairline (guidelines p.53), then the body.
 */
export default function NumberedSection({ id, numeral, title, children, tight = false }: NumberedSectionProps) {
  const titleId = `${id}-title`;
  return (
    <section id={id} className={`mk-section ${tight ? 'mk-section--tight' : ''}`.trim()} aria-labelledby={titleId}>
      <div className="mk-container">
        <div className="mk-section__head">
          <span className="mk-section__num t-details" aria-hidden="true">
            {numeral}
          </span>
          <h2 id={titleId} className="mk-section__title t-details">
            {title}
          </h2>
        </div>
        {children}
      </div>
    </section>
  );
}
